<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName"></div>
  </div>
</template>

<script>
import create from "../../create";
import {CHART_TYPE} from "@/option/common/dict";
import util from "@/option/common/util";
import {unref} from "vue";

export default create({
  name: "bar3D",
  methods: {
    updateChart() {
      let optionData = this.deepClone(this.dataChart);
      let xData,
          barData,
          maxData = [10000000, 10000000, 10000000, 10000000, 10000000];
      if (this.isDataCenter) {
        optionData = this.getDimentionOption();
        xData = optionData.categories;
        barData = optionData.series[0].data;
        if (optionData.series[1]) {
          maxData = optionData.series[1].data;
        }
        /*       option.legend = this.getOptionLegend(_op.series); */
      } else {
        xData = optionData.categories;
        barData = optionData.series[0].data;
      }


      const bgColor = [
        {s: '#299DEA', e: '#32C2E7'},
        {s: '#29E4EA', e: '#32E1E7'},
        {s: '#2A4790', e: '#3265E7'}]

      let option = {
        backgroundColor: 'transparent',
        grid: {
          top: '10%',
          left: '-5%',
          bottom: '5%',
          right: '5%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'item',
        },
        animation: false,
        xAxis: [
          {
            type: 'category',
            data: xData,
            axisTick: {
              alignWithLabel: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: '#ddd',
              },
              margin: 30,
            },
            interval: 1,
          },
        ],
        yAxis: [
          {
            show: false,
            type: 'value',
          },
        ],
        series: [
          {
            name: '上部圆',
            type: 'pictorialBar',
            silent: true,
            symbolSize: [60, 15],
            symbolOffset: [0, -6],
            symbolPosition: 'end',
            z: 12,
            itemStyle: {
              color: function (params) {
                const ss = bgColor[params.dataIndex]?.e ?? '#226777'
                return ss
              }
            },
            data: maxData,
          },
          {
            name: '背景圆柱',
            type: 'bar',
            barWidth: '60',
            barGap: '10%', // Make series be overlap
            barCateGoryGap: '10%',
            itemStyle: {
              normal: {
                color: function (params) {
                  return new echarts.graphic.LinearGradient(0, 0, 0, 0.7, [
                    {
                      offset: 0,
                      color: bgColor[params.dataIndex]?.e ?? '#226777',
                    },
                    {
                      offset: 1,
                      color: bgColor[params.dataIndex]?.e ?? '#226777',
                    },
                  ])
                },
                opacity: 0.2,
              },
            },
            data: maxData,
          },
          {
            name: '内部柱子',
            type: 'bar',
            barWidth: 60,
            z: 10,
            barGap: '-100%',
            label: {
              normal: {
                show: true,
                position: 'top',
                fontSize: 15,
                fontWeight: 'bold',
                color: '#fff',
                formatter: '{c}%'
              },
            },
            itemStyle: {
              //lenged文本
              opacity: 0.8,
              color: function (params) {
                const s = bgColor[params.dataIndex]?.s ?? '#26d1ae'
                const e = bgColor[params.dataIndex]?.e ?? '#226e81'
                return new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1,
                    [
                      {
                        offset: 0,
                        color: s, // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: e, // 100% 处的颜色
                      },
                    ],
                    false
                );
              },
            },

            data: barData,
          },
          {
            name: '上部圆',
            type: 'pictorialBar',
            silent: true,
            symbolSize: [60, 15],
            symbolOffset: [0, -6],
            symbolPosition: 'end',
            z: 12,
            itemStyle: {
              color: function (params) {
                const ss = bgColor[params.dataIndex]?.e ?? '#226777'
                return ss
              }
            },
            data: barData,
          },
          {
            name: '底部圆',
            type: 'pictorialBar',
            silent: true,
            symbolSize: [60, 15],
            symbolOffset: [0, 7],
            z: 8,
            itemStyle: {
              color: function (params) {
                const ss = bgColor[params.dataIndex]?.e ?? '#226777'
                return ss
              },
            },
            data: barData,
          },
        ],
      };

      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    },
  },
});
</script>
